import { useState, useEffect } from "react";
import axios from "axios";
import { backend_url } from "@/constants";
import { Endpoints } from "@/utils/api/endpoints";
import type {
  AnalyticsData,
  AnalyticsPeriod,
  AnalyticsResponse,
} from "../types";

export const useAnalytics = (period: AnalyticsPeriod) => {
  const [data, setData] = useState<AnalyticsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get<AnalyticsResponse>(
          `${backend_url}/${Endpoints.admin.analytics}`,
          {
            params: { period },
            withCredentials: true,
          }
        );
        console.log("Analytics API response:", response);
        console.log("Analytics data content:", response.data.content);
        setData(response.data.content);
      } catch (err: any) {
        console.error("Analytics API error:", err);
        console.error("Error response:", err.response);
        const errorMessage =
          err.response?.data?.message ||
          err.message ||
          "Failed to load analytics";
        setError(errorMessage);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [period]);

  return { data, loading, error };
};
